<template>
  <!-- <div class="tome" :style="{ bottom: offsetBottom + 'px' }" @click="$router.go(-1)" /> -->
  <div v-if="isPc" class="tome" :style="{ bottom: offsetBottom + 'px' }" @click="onBackHandle" />
  <div v-else class="tome" :style="{ bottom: offsetBottom + 'px' }"  @touchstart.prevent="move" />
</template>
<script>
export default {
  name: 'toback',
  props: {
    offsetBottom: {
      type: String,
      default: '90'
    },
  },
  data() {
    return {
      isPc: true,
      intervalId: null
    }
  },
  mounted() {
    if ((navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
      //跳转移动端页面
      this.isPc = false
    }else{
      //跳转pc端页面
      this.isPc = true
    }
  },
  methods: {
    // 悬浮按钮的拖拽事件,合并单击事件行为
    move(e) {
      let startTime = (new Date()).getTime()//获取当前按下时的时间
      let odiv = e.target//获取目标元素
      const maxLeft = window.outerWidth - 40 //left最大值,40是目标元素的宽
      const maxTop = window.outerHeight - 40 //top最大值，40是目标元素的高
      let t = e.targetTouches[0]
      let x = t.clientX - t.target.offsetLeft //触碰点当前距离事件源的左距
      let y = t.clientY - t.target.offsetTop //触碰点当前距离事件源的上距
      document.ontouchmove = (e) => {//鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置(默认20)，得到元素的位置
        const touch = e.changedTouches[0]
        let left = touch.clientX - x
        let top = touch.clientY - y
        // 设置移动范围
        if(left <= 0) left = 0
        if(left >= maxLeft) left = maxLeft 
        if(top <= 46) top = 46 //最小为头部底边
        if(top >= maxTop) top = maxTop
        //移动当前元素(改变定位)
        odiv.style.left = left + 'px'
        odiv.style.top = top + 'px'
      }
      document.ontouchend = () => {
        document.ontouchmove = null
        e.preventDefault()
        var nowTime = (new Date()).getTime()//松开时的时间
        // 小于300ms可以识别为点击事件的范围,最好设置为50
        if(nowTime - startTime <= 500) {
          this.onBackHandle()
        }
      }
    },
    onBackHandle(){
      const path =this.$route.path
      if(path==="/activity") return
      this.$router.replace("/activity")
    }
  }
}
</script>


<style lang="less" scoped>
.tome {
  width: 62px;
  height: 62px;
  background: url('../../image/yky/返回@2x.png') no-repeat;
  background-size: contain;
  position: fixed;
  right: 14px;
  z-index: 10;
}
</style>